import React from 'react';

function Facebook(props: object) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.254 20.5891C16.185 19.9722 20 15.7651 20 10.667C20 5.14414 15.5229 0.666992 10 0.666992C4.47715 0.666992 0 5.14414 0 10.667C0 15.4385 3.34176 19.4294 7.8125 20.427V13.7049H5.625V10.667H7.8125V9.34161C7.8125 5.9444 9.10576 4.37154 12.4391 4.37154C13.0699 4.37154 14.1596 4.49529 14.6068 4.61904V7.38153C14.3713 7.35758 13.96 7.3456 13.4531 7.3456C11.8163 7.3456 11.25 7.96437 11.25 9.57714V10.667H14.4471L13.8883 13.7049H11.254V20.5891Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Facebook;
